import axiosInstance from "../Utils/axiosInstance";
import { ContactApi } from "../Constants/api";

export const getContactsApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${ContactApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
